import { ItemI } from "@kargo/shared-components.krg-select";
import { PATHS } from "./paths";

export const DEFAULT_PAGINATION_LIMIT = 12;
export const MEDIAS_FETCH_LIMIT = DEFAULT_PAGINATION_LIMIT;
export const MAX_BULK_EDIT_LIMIT = 100;
export const MAX_ALLOWED_VIDEO_UPLOADS = 10;
export const UPDATE_PROGRESS_ON_PERCENTAGE = 25;
export const WARNING_TEXT_COLOR = "#FBC02D";
export const isAddToPlaylistEnabled = false;
export const playlistCopyEnabled = false;

export const MIN_CHARACTERS_FOR_SEARCH = 3;
export const DEBOUNCE_TIME_FOR_SEARCH_IN_MICROSECONDS = 500;
export const PLAYLIST_FETCH_LIMIT = 100;
export const NavItems = {
  PUBLISHER_HUB: "Publisher Hub",
  MEDIA_GALLERY: "Media Gallery",
  REPORTS: "Reports",
};

export const sidebarNavItems = [
  { path: PATHS.PUBLISHER_HUB, text: NavItems.PUBLISHER_HUB },
  { path: PATHS.MEDIA_GALLERY, text: NavItems.MEDIA_GALLERY },
  { path: PATHS.REPORTING, text: NavItems.REPORTS },
];

export const ALLOWED_VTT_FILES_MIME_TYPES = [
  `text/vtt`,
  `text/srt`,
  `text/plain`,
];

export const PLAYLIST_MIN_TITLE_LENGTH = 5;
export const PLAYLIST_MAX_TITLE_LENGTH = null;
export const playlistTypes = [
  {
    id: 1,
    name: "Category",
  },
  {
    id: 2,
    name: "Tag",
  },
  {
    id: 3,
    name: "Custom",
  },
];

export const PLAYLIST_SORT_TYPES: ItemI[] = [
  {
    value: `newest`,
    text: `Date added (newest)`,
  },
  {
    value: `oldest`,
    text: `Date added (oldest)`,
  },
  {
    value: `shuffle`,
    text: `Shuffle`,
  },
  {
    value: `manual`,
    text: `Manual`,
  },
];

export const SINGLE_MEDIA_ERROR_MESSAGES = {
  404: "Video not found",
  403: "You are not authorized to access this video",
  500: "Something went wrong. Please try refreshing the page.",
  400: "Bad request",
};

export const THUMBNAIL_STYLE: React.CSSProperties = {
  width: "70px",
  height: "40px",
  objectFit: "contain" as const,
  borderRadius: "4px",
  border: "1px solid #e0e0e0",
};
